// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_A0K","cls2":"SingularMentionCitationModal-cls2_Kpt SingularMentionCitationModal-cls1_A0K"};